import { NS } from "./actions";
import initialState from "../../../../reducers/initialState";

const NsReducer = (state = initialState, action) => {
  switch (action.type) {
    //initialState
    case NS.NS_MODAL_TOGGLE: {
      return {
        ...state,
        nsModal: !state.nsModal,
        tab: action.data,
      };
    }

    default:
      return state;
  }
};

export default NsReducer;
